import axiosInstance from './axiosInstance';

export const createTraining = async (trainingData) => {
  try {
    const response = await axiosInstance.post('/training/create', trainingData);
    return response.data;
  } catch (error) {
    throw error;
  }
};



export const fetchTrainingsDashboard = async (params) => {
  try {
    const response = await axiosInstance.post('/training/dashboard', params);
    return response.data;
  } catch (error) {
    // console.error('Error fetching trainings:', error);
    throw error;
  }
};


export const updateTraining = async (trainingData) => {
  try {
    const response = await axiosInstance.post('/training/update', trainingData);
    return response.data;
  } catch (error) {
    // console.error('Error updating training:', error);
    throw error;
  }
};

export const deleteTraining = async (trainingId) => {
  try {
    const response = await axiosInstance.post(`/training/delete?id=${trainingId}`);
    return response.data;
  } catch (error) {
    // console.error('Error deleting training:', error);
    throw error;
  }
};
